(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["diy-project-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-section-type="diy-project-gallery"]');
    sections.forEach(function (root) {
      var grid = root.querySelector('[data-diy-grid]');
      var emptyMsg = root.querySelector('[data-diy-empty-filtered]');
      var filterBtns = root.querySelectorAll('[data-diy-filter]');
      var cards = root.querySelectorAll('[data-diy-card]');

      filterBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var target = btn.getAttribute('data-diy-filter');
          filterBtns.forEach(function (b) {
            var active = b === btn;
            b.classList.toggle('is-active', active);
            b.setAttribute('aria-selected', active ? 'true' : 'false');
          });

          var visibleCount = 0;
          cards.forEach(function (card) {
            var cat = card.getAttribute('data-category');
            var show = target === 'all' || cat === target;
            card.classList.toggle('is-hidden', !show);
            if (show) visibleCount++;
          });
          if (emptyMsg) {
            emptyMsg.hidden = visibleCount > 0;
          }
        });
      });

      var storyToggles = root.querySelectorAll('[data-diy-story-toggle]');

      function syncStory(toggle) {
        if (toggle.getAttribute('aria-expanded') === 'true') return;
        var text = document.getElementById(toggle.getAttribute('aria-controls'));
        if (!text) return;
        var overflows = text.scrollHeight - text.clientHeight > 2;
        text.classList.toggle('is-truncated', overflows);
        toggle.hidden = !overflows;
      }

      function syncStories() {
        storyToggles.forEach(syncStory);
      }

      storyToggles.forEach(function (toggle) {
        var text = document.getElementById(toggle.getAttribute('aria-controls'));
        if (!text) return;
        var label = toggle.querySelector('[data-diy-story-toggle-label]');
        var story = text.parentNode;
        var animTimer;
        toggle.addEventListener('click', function () {
          var expanded = toggle.getAttribute('aria-expanded') === 'true';
          var fromHeight = text.clientHeight;
          toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
          text.classList.toggle('is-clamped', expanded);
          text.classList.toggle('is-truncated', expanded);
          if (label) label.textContent = expanded ? 'Read more' : 'Read less';
          var toHeight = expanded ? text.clientHeight : text.scrollHeight;
          // Scale duration to the distance travelled so a short story does not
          // dawdle and a very long one does not snap. ~100ms for a typical
          // 4-line reveal, capped so nothing feels sluggish.
          var travel = Math.abs(toHeight - fromHeight);
          var dur = Math.round(Math.min(300, Math.max(100, 70 + travel * 0.55)));
          if (story) story.style.setProperty('--diy-story-dur', dur + 'ms');
          // Pin the starting height with transitions suppressed. Measuring the
          // clamped height above already committed it as the transition
          // baseline, so without this the collapse animates ~0.3px and looks
          // instant.
          text.style.transition = 'none';
          text.style.maxHeight = fromHeight + 'px';
          void text.offsetHeight;
          text.style.transition = '';
          text.style.maxHeight = toHeight + 'px';
          clearTimeout(animTimer);
          animTimer = setTimeout(function () {
            text.style.maxHeight = '';
          }, dur + 40);
        });
      });

      syncStories();
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(syncStories);
      }
      var storyResizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(storyResizeTimer);
        storyResizeTimer = setTimeout(syncStories, 150);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
